import {Component} from "@angular/core";
import {Page} from "../../orchestration/page";
import {OrderingContextModel} from "../ordering-context.model";
import {NavigationService} from "../../orchestration/navigation.service";
import {OrderingContextController} from "../ordering-context.controller";
import {OrderingContextEvents} from "../ordering-context-events";
import {OrderModel} from "../../order/order.model";
import {OrderEvents, OrderInitiationStatus} from "../../order/order-events";
import {MessageLevel} from "../../notification/message/message";
import {OrderType} from "../../order/order";

@Component({
    selector: "woa-ordering-context-edit-page",
    templateUrl: "./ordering-context-edit-page.component.html",
    providers: [{provide: Page, useExisting: OrderingContextEditPageComponent}]
})
export class OrderingContextEditPageComponent extends Page {
    OrderingContextEvents = OrderingContextEvents;
    OrderEvents = OrderEvents;
    OrderInitiationStatus = OrderInitiationStatus;
    OrderType = OrderType;
    MessageLevel = MessageLevel;

    constructor(public orderingContextModel: OrderingContextModel,
                public orderingContextController: OrderingContextController,
                public orderModel: OrderModel,
                public navigationService: NavigationService) {
        super();
    }

    get title(): string {
        return this.orderingContextModel.orderType === OrderType.ORDER_AHEAD ? "woa.heading.ordering-context.order-details.orderAhead"
            : this.orderingContextModel.orderType === OrderType.ORDER_DELIVERY ? "woa.heading.ordering-context.order-details.orderDelivery"
                : this.orderingContextModel.orderType === OrderType.ORDER_AT_TABLE ? "woa.heading.ordering-context.order-details.orderAtTable"
                    : "woa.heading.ordering-context.orderDetails";
    }

    get storeLabel(): string {
        return this.orderingContextModel.orderType === OrderType.ORDER_AHEAD ? "woa.label.ordering-context.selected-store.orderAhead"
            : this.orderingContextModel.orderType === OrderType.ORDER_DELIVERY ? "woa.label.ordering-context.selected-store.orderDelivery"
                : this.orderingContextModel.orderType === OrderType.ORDER_AT_TABLE ? "woa.label.ordering-context.selected-store.orderAtTable"
                    : undefined;
    }

    get confirmedAddress(): string {
        return this.orderingContextModel.addressTrusted ? this.orderingContextModel.address.formattedAddress : undefined;
    }

    get orderTime(): string {
        return this.orderingContextModel.expectedCompletion ? "'" + this.orderingContextModel.getFormattedExpectedCompletion() + "'"
            : this.orderingContextModel.canShowAsapSelectionTime ? "woa.label.ordering-context.asap"
                : undefined;
    }

    get showTimeSpinner(): boolean {
        return !this.orderingContextModel.expectedCompletion && this.orderingContextModel.canShowAsapSelectionTime &&
            !OrderingContextEvents.evaluatingExpectedCompletionChange$.value && OrderEvents.orderInitiationStatus$.value === OrderInitiationStatus.INITIATING;
    }

    get etaLabel(): string {
        return !this.orderingContextModel.canShowETA || !this.orderModel.orderEta || OrderingContextEvents.evaluatingExpectedCompletionChange$.value || OrderEvents.orderInitiationStatus$.value === OrderInitiationStatus.INITIATING ? undefined
            : this.orderingContextModel.orderType === OrderType.ORDER_AHEAD ? "woa.label.ordering-context.eta.orderAhead"
                : "woa.label.ordering-context.eta.orderDelivery";
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/ordering-context-edit-page/ordering-context-edit-page.component.ts